module.exports = __webpack_public_path__ + "static/agro-mobile-938a2552a4db3fd81c93794f69c502ee.png";